import { render, staticRenderFns } from "./SpecsView.vue?vue&type=template&id=018665d6&scoped=true"
import script from "./SpecsView.vue?vue&type=script&lang=js"
export * from "./SpecsView.vue?vue&type=script&lang=js"
import style0 from "./SpecsView.vue?vue&type=style&index=0&id=018665d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018665d6",
  null
  
)

export default component.exports